import React from 'react';
import { isJSON } from 'utilities/index';
import SparkGenerateOutput from './SparkGenerateOutput';
import { Box } from '@mui/material';
import SparkMarkdown from './SparkMarkdown';

type Props = {
  output: string;
  transformReference?: (promptString: string) => React.ReactNode;
};

function SparkDynamicOutput({ output, transformReference }: Props) {
  return (
    <Box>
      {isJSON(output) ? (
        <SparkGenerateOutput
          output={output}
          transformReference={transformReference}
        />
      ) : (
        <Box className="spark-content">
          <SparkMarkdown>{output}</SparkMarkdown>
        </Box>
      )}
    </Box>
  );
}

export default SparkDynamicOutput;
